import { lazy } from 'react';
import { withSuspense } from '@/hocs/withSuspense';

export const AccessDeniedPageLazy = withSuspense(lazy(() => import('./access-denied.page')));
